import { Svg, Path, G } from "react-native-svg";
import { SvgProps } from "react-native-svg";

const PlayCircle = (props: SvgProps) => (
  <Svg {...props} width={32} height={32} viewBox="0 0 32 32" fill="none">
    <G id="play-circle">
      <G id="Vector">
        <Path
          d="M16 29.3334C23.3638 29.3334 29.3333 23.3639 29.3333 16.0001C29.3333 8.63628 23.3638 2.66675 16 2.66675C8.63616 2.66675 2.66663 8.63628 2.66663 16.0001C2.66663 23.3639 8.63616 29.3334 16 29.3334Z"
          stroke="#090A0A"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M13.3333 10.6667L21.3333 16.0001L13.3333 21.3334V10.6667Z"
          stroke="#090A0A"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
    </G>
  </Svg>
);

export default PlayCircle;
